export const APPS_READ = "APPS_READ";
export const APPS_WRITE = "APPS_WRITE";

export const CONNECTOR_READ = "CONNECTOR_READ";
export const CONNECTOR_WRITE = "CONNECTOR_WRITE";

export const DATASETS_READ = "DATASETS_READ";
export const DATASETS_WRITE = "DATASETS_WRITE";

export const EXECUTIONS_READ = "EXECUTIONS_READ";
export const EXECUTIONS_WRITE = "EXECUTIONS_WRITE";

export const FILES_READ = "FILES_READ";
export const FILES_WRITE = "FILES_WRITE";

export const INVITATIONS_READ = "INVITATIONS_READ";
export const INVITATIONS_WRITE = "INVITATIONS_WRITE";

export const MODEL_READ = "MODEL_READ";
export const MODEL_WRITE = "MODEL_WRITE";

export const ORGANIZATIONS_READ = "ORGANIZATIONS_READ";
export const ORGANIZATIONS_WRITE = "ORGANIZATIONS_WRITE";

export const POLICIES_READ = "POLICIES_READ";
export const POLICIES_WRITE = "POLICIES_WRITE";

export const SCHEDULED_EXECUTION_READ = "SCHEDULED_EXECUTION_READ";
export const SCHEDULED_EXECUTION_WRITE = "SCHEDULED_EXECUTION_WRITE";

export const MONITOR_ALERT_READ = "MONITOR_ALERT_READ";
export const MONITOR_ALERT_WRITE = "MONITOR_ALERT_WRITE";

export const USERS_READ = "USERS_READ";
export const USERS_WRITE = "USERS_WRITE";

export const AVERROES_USER = "AVERROES_USER";
export const AVERROES_ADMIN = "AVERROES_ADMIN";

export const CAMERA_READ = "CAMERA_READ";
export const CAMERA_WRITE = "CAMERA_WRITE";

export const MONITOR_READ = "MONITOR_READ";
export const MONITOR_WRITE = "MONITOR_WRITE";
